import script from "./plateformList.vue?vue&type=script&lang=ts&setup=true"
export * from "./plateformList.vue?vue&type=script&lang=ts&setup=true"

import "./plateformList.vue?vue&type=style&index=0&id=f5eea1f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5eea1f6"]])

export default __exports__